import "../Admin.css";
import { useEffect, useState } from "react";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import post from "../functions/post.js";
import get from "../functions/get.js";

import Loading from "../components/loading.jsx";
import Button from "../components/button.jsx";
import Exercises from "./exercises.jsx";
import CreateQuiz from "./create_quiz.jsx";

const Admin = () => {

    const location = useLocation();
    const [ loading, setLoading ] = useState(true);
    const [ loginSuccess, setLoginSuccess ] = useState(false);
    const [ warning, setWarning ] = useState("");

    const onSession = (res, data) => {

        if(!res) {
            setWarning("Server nicht erreichbar!");
            setLoading(false);
            return;
        };

        setLoading(false);

        if(res.status === 200) {
            setLoginSuccess(true);
            setWarning("");
        };

        if(res.status === 400) {
            setWarning(data.error);
        };

    };
    
    useEffect(() => {

        get("/check/session", onSession, (res, data) => {
            setLoading(false);
        });

    }, []);

    const [ admin, setAdmin ] = useState({
        name: "",
        password: "",
    });

    const changeAdmin = (field, value) => {
        setAdmin(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const adminLogin = (e) => {

        e.preventDefault();

        setLoading(true);
        post("/login", admin, onSession, onSession);

    };

    const [ largeScreen, setLargeScreen ] = useState(window.innerWidth >= 1100);

    useEffect(() => {

        const handleResize = () => {

            setLargeScreen(window.innerWidth >= 1100);

        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };

    }, []);

    const loggedOut = {
        height: "100vh",
        width: "100vw",
        maxWidth: "1400px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: largeScreen ? "50px" : "20px",
    };

    const loggedIn = {
        height: "auto",
        width: "100vw",
        maxWidth: "1400px",
        display: "block",
        padding: largeScreen ? "80px 50px" : "80px 20px",
    };

  return (
    <div className="admin" style={loginSuccess ? loggedIn : loggedOut}>
        {loading &&
            <Loading />
        }

        {(!loading && !loginSuccess) &&
            <form style={{width: "auto"}}>

                <h1 className="title title-small">WILLKOMMEN</h1>
                
                <div className="admin-form-elem flex-col">
                    <label>Name: </label>

                    <input type="name" value={admin.name} onChange={(e) => changeAdmin("name", e.target.value)} />
                </div>

                <div className="admin-form-elem flex-col">
                    <label>Passwort: </label>

                    <input type="password" value={admin.password} onChange={(e) => changeAdmin("password", e.target.value)} />
                </div>
                
                <div style={{marginTop: "10px"}} onClick={adminLogin}>
                    <Button className="button-yellow" text="Login" />
                </div>

            </form>
        }

        {(!loading && loginSuccess && location.pathname === "/admin") &&
            <div>
                <h1 className="title title-small">WILLKOMMEN</h1>

                <div className="admin-panel">

                    <p>Hier kannst du neue Übungen zu den verschiedenen Themen entwerfen oder ein neues Quiz erstellen.</p>

                    <p style={{marginTop: "10px", marginBottom: "10px"}}>
                        Wähle ein Thema aus, überlege dir einen möglichen Satz und lass ihn von unserer KI analysieren. 
                        In einem weiteren Schritt kannst du dann zwischen verschiedenen Aufgabenstellungen auswählen (z.B. Verben erkennen, konjugieren oder dem Bezugswort zuweisen).
                    </p>

                    <Link to="/admin/uebungen">
                        <Button className="button-yellow" text="Übungen" />
                    </Link>

                    <br />
                    
                    <Link to="/admin/quizzes">
                        <Button className="button-blue" text="Quiz" />
                    </Link>

                </div>
            </div>
        }

        {(!loading && warning) &&
            <div className="start-warning">
                <p>{warning}</p>
            </div>
        }

        {(!loading && loginSuccess) && (
            <Routes>
                <Route path="uebungen/*" element={<Exercises />} />
                <Route path="quizzes/*" element={<CreateQuiz />} />
            </Routes>
        )}
    </div>
  );
}; export default Admin;